import { HttpParams } from '@angular/common/http';

export interface Pagination {
  page: number;
  size: number;
  total?: number;
  sort?: string[];
}

export interface Search {
  query?: string | null;
  role?: string | null;
}

export interface SearchWithPagination extends Search, Pagination {}

export const createRequestOption = (req?: any): HttpParams => {
  let options: HttpParams = new HttpParams();

  if (req) {
    Object.keys(req).forEach(key => {
      if (key !== 'sort' && !!req[key]) {
        options = options.set(key, req[key]);
      }
    });

    if (req.sort) {
      req.sort.forEach((val: string) => {
        options = options.append('sort', val);
      });
    }
  }

  return options;
};
